export default __webpack_public_path__ + "static/media/email_sent.06b092e8.svg";